const options = [
  {
    value: null,
    label: "Select an option",
  },
  {
    value: "Bluewater",
    label: "Bluewater",
  },
  {
    value: "Brent Cross",
    label: "Brent Cross",
  },
  {
    value: "Cambridge",
    label: "Cambridge",
  },
  {
    value: "Canary Wharf",
    label: "Canary Wharf",
  },
  {
    value: "Cardiff",
    label: "Cardiff",
  },
  {
    value: "Cheadle",
    label: "Cheadle",
  },
  {
    value: "Chelmsford",
    label: "Chelmsford",
  },
  {
    value: "Cheltenham",
    label: "Cheltenham",
  },
  {
    value: "Chichester",
    label: "Chichester",
  },
  {
    value: "Cribbs Causeway",
    label: "Cribbs Causeway",
  },
  {
    value: "Edinburgh",
    label: "Edinburgh",
  },
  {
    value: "Exeter",
    label: "Exeter",
  },
  {
    value: "Glasgow",
    label: "Glasgow",
  },
  {
    value: "High Wycombe",
    label: "High Wycombe",
  },
  {
    value: "Horsham",
    label: "Horsham",
  },
  {
    value: "Ipswich",
    label: "Ipswich",
  },
  {
    value: "Kingston",
    label: "Kingston",
  },
  {
    value: "Leeds",
    label: "Leeds",
  },
  {
    value: "Leicester",
    label: "Leicester",
  },
  {
    value: "Liverpool",
    label: "Liverpool",
  },
  {
    value: "Milton Keynes",
    label: "Milton Keynes",
  },
  {
    value: "Newcastle",
    label: "Newcastle",
  },
  {
    value: "Norwich",
    label: "Norwich",
  },
  {
    value: "Nottingham",
    label: "Nottingham",
  },
  {
    value: "Oxford",
    label: "Oxford",
  },
  {
    value: "Oxford Street",
    label: "Oxford Street",
  },
  {
    value: "Peter Jones",
    label: "Peter Jones",
  },
  {
    value: "Poole",
    label: "Poole",
  },
  {
    value: "Reading",
    label: "Reading",
  },
  {
    value: "Solihull",
    label: "Solihull",
  },
  {
    value: "Southampton",
    label: "Southampton",
  },
  {
    value: "Stratford City",
    label: "Stratford City",
  },
  {
    value: "Swindon Outlet",
    label: "Swindon Outlet",
  },
  {
    value: "Trafford",
    label: "Trafford",
  },
  {
    value: "Welwyn",
    label: "Welwyn",
  },
  {
    value: "White City",
    label: "White City",
  },
];

export default options;
